import actions from './constants';

export const showSaveSearch = (category, code, isNew) => ({
  type: actions.SHOW_SAVE_SEARCH,
  category,
  code,
  isNew,
});

export const hideSaveSearch = () => ({
  type: actions.HIDE_SAVE_SEARCH,
});

export const confirmSearchDeletion = (category, code) => ({
  type: actions.SHOW_DELETE_SEARCH,
  category,
  code,
});

export const confirmSearchesDeletion = (category) => ({
  type: actions.SHOW_DELETE_SEARCHES,
  category,
});

export const hideDeleteSearch = () => ({
  type: actions.HIDE_DELETE_SEARCH,
});

export const updateSearchProperties = (category, code, properties) => ({
  type: actions.UPDATE_SEARCH_PROPERTIES,
  category,
  code,
  properties,
});

export const updateActiveSearchProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_SEARCH_PROPERTIES,
  properties,
});

export const toggleOmniSearchFlags = (category, code, linksFlag, kbFlag, datasetsFlag) => ({
  type: actions.TOGGLE_OMNI_SEARCH_FLAGS,
  category,
  code,
  linksFlag,
  kbFlag,
  datasetsFlag,
});

export const performFind = (
  category,
  code,
  page,
  pageSize,
  append = false,
  query = null,
  filter = null,
) => ({
  type: actions.FIND,
  category,
  code,
  page,
  pageSize,
  append,
  query,
  filter,
});

export const refreshFind = (category, code, page) => ({
  type: actions.REFRESH_FIND,
  category,
  code,
  page,
});

export const showFindResults = (
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  facets,
  info,
  warnings,
) => ({
  type: actions.SHOW_FIND_RESULTS,
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  facets,
  info,
  warnings,
});

export const showFindError = (category, code, error) => ({
  type: actions.SHOW_FIND_ERROR,
  category,
  code,
  error,
});

export const fetchSearches = (category, page, pageSize, append) => ({
  type: actions.FETCH_SEARCHES,
  category,
  page,
  pageSize,
  append,
});

export const refreshSearches = (category, page) => ({
  type: actions.REFRESH_SEARCHES,
  category,
  page,
});

export const toggleSearchSelected = (category, code) => ({
  type: actions.TOGGLE_SEARCH_SELECTED,
  category,
  code,
});

export const toggleSearchesSelected = (category, selected) => ({
  type: actions.TOGGLE_SEARCHES_SELECTED,
  category,
  selected,
});

export const updateSearchesFilter = (category, value) => ({
  type: actions.UPDATE_SEARCHES_FILTER,
  category,
  value,
});

export const updateSearchesFlags = (category, { privateFlag, internalFlag }) => ({
  type: actions.UPDATE_SEARCHES_FLAGS,
  category,
  privateFlag,
  internalFlag,
});

export const showSearches = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_SEARCHES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showSearchesError = (category, error) => ({
  type: actions.SHOW_SEARCHES_ERROR,
  category,
  error,
});

export const closeSearches = ({ category }) => ({
  type: actions.CLOSE_SEARCHES,
  category,
});

export const fetchSearch = (category, code, page, pageSize, auto) => ({
  type: actions.FETCH_SEARCH,
  category,
  code,
  page,
  pageSize,
  auto,
});

export const showSearch = (category, code, result) => ({
  type: actions.SHOW_SEARCH,
  category,
  code,
  result,
});

export const showSearchError = (category, code, error, auto) => ({
  type: actions.SHOW_SEARCH_ERROR,
  category,
  code,
  error,
  auto,
});

export const deleteSearch = ({ items }) => ({
  type: actions.DELETE_SEARCH,
  items,
});

export const destroySearch = (items, silent) => ({
  type: actions.DESTROY_SEARCH, items, silent,
});

export const destroySearchError = (items) => ({
  type: actions.DESTROY_SEARCH_ERROR, items,
});

export const closeSearch = ({ category, code }) => ({
  type: actions.CLOSE_SEARCH,
  category,
  code,
});

export const createSearch = () => ({
  type: actions.CREATE_SEARCH,
});

export const newSearch = (result) => ({
  type: actions.NEW_SEARCH, result,
});

export const newSearchError = (error) => ({
  type: actions.NEW_SEARCH_ERROR,
  error,
});

export const updateSearch = () => ({
  type: actions.UPDATE_SEARCH,
});

export const editSearch = (code, result) => ({
  type: actions.EDIT_SEARCH, code, result,
});

export const editSearchError = (error) => ({
  type: actions.EDIT_SEARCH_ERROR,
  error,
});

export const fetchSearchConfig = () => (({
  type: actions.FETCH_SEARCH_CONFIG,
}));

export const showSearchConfig = (searchConfig) => ({
  type: actions.SHOW_SEARCH_CONFIG,
  searchConfig,
});

export const showSearchConfigError = (error) => ({
  type: actions.SHOW_SEARCH_CONFIG_ERROR,
  error,
});

export const decodeSearchQuery = (category, code, query) => ({
  type: actions.DECODE_SEARCH_QUERY,
  category,
  code,
  query,
});

export const toggleSearchesPresentation = (category, display) => ({
  type: actions.TOGGLE_SEARCHES_PRESENTATION,
  category,
  display,
});
